/* ClueVine — remembered start-sheet choices (play mode + endless difficulty, per mode). */

import type { AnyPuzzleMode, PlayMode } from '../engine/types';
import { loadSlice, saveSlice, type SliceConfig } from './persistence';

export interface StartPrefs {
  playMode: PlayMode;
  difficultyId: string;
}

const slice: SliceConfig<Record<string, StartPrefs>> = {
  name: 'start-prefs',
  version: 1,
  defaults: () => ({}),
};

export function getStartPrefs(mode: AnyPuzzleMode): StartPrefs {
  const saved = loadSlice(slice)[mode.id];
  const difficultyId =
    saved && mode.difficulties.some((d) => d.id === saved.difficultyId) ? saved.difficultyId : mode.defaultDifficultyId;
  return { playMode: saved?.playMode === 'endless' ? 'endless' : 'daily', difficultyId };
}

export function setStartPrefs(modeId: string, prefs: StartPrefs): void {
  const all = loadSlice(slice);
  saveSlice(slice, { ...(typeof all === 'object' && all ? all : {}), [modeId]: prefs });
}
